import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=93131ace&scoped=true&"
import script from "./CustomersList.vue?vue&type=script&lang=js&"
export * from "./CustomersList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/table.css?vue&type=style&index=0&id=93131ace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93131ace",
  null
  
)

export default component.exports